import {
  ISalePageDetailResponseProduct,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import { Divider, Element } from '@vuddy/components';
import { ChangeEvent, Fragment } from 'react';
import { PurchaseCheckItem } from './PurchaseCheckItem';
import { PurchaseRadioItem } from './PurchaseRadioItem';

interface DigitalItemListProps {
  itemList: (ISalePageDetailResponseProduct &
    ISalePageProductAdditionalInformResponse)[];
  selectedId?: number;
  selectedIds?: number[];
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onToggle?: (itemId: number) => void;
  onCodeInputClick?: (itemId: number) => void;
  // key: productId, value: 검증된 promotionCode
  verifiedProductCodes?: Map<number, string>;
  selectionMode?: 'single' | 'multiple';
}

export const DigitalItemList = ({
  itemList,
  selectedId,
  selectedIds = [],
  onChange,
  onToggle,
  onCodeInputClick,
  verifiedProductCodes,
  selectionMode = 'single',
}: DigitalItemListProps) => {
  return (
    <Element paddingX="padding_small">
      {itemList.map(item => (
        <Fragment key={item.id}>
          {selectionMode === 'multiple' ? (
            <PurchaseCheckItem
              item={item}
              checked={selectedIds.includes(item.id)}
              onChange={() => onToggle?.(item.id)}
              hasVerificationCode={item.requiresPromotionCode}
              verificationCodeName={verifiedProductCodes?.get(item.id)}
              onCodeInputClick={() => onCodeInputClick?.(item.id)}
            />
          ) : (
            <PurchaseRadioItem
              item={item}
              selectedId={selectedId}
              onChange={onChange}
              hasVerificationCode={item.requiresPromotionCode}
              verificationCodeName={verifiedProductCodes?.get(item.id)}
              onCodeInputClick={() => onCodeInputClick?.(item.id)}
            />
          )}
          <Divider />
        </Fragment>
      ))}
    </Element>
  );
};
